import { render } from "./aio-login-text.vue?vue&type=template&id=5ac895fe"
import script from "./aio-login-text.vue?vue&type=script&lang=js"
export * from "./aio-login-text.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__